import { useEffect } from 'react';
import { SelectedProduct, ProductType } from '../common/CommonTypes';
import { useNavigate, useLocation } from 'react-router';
import { RoutePaths } from '../../Constants/Common';

type LocationState = {
    product: ProductType;
    productRoute: string;
};

export const useSelectedProduct = (): SelectedProduct => {
    const location = useLocation();
    const { product, productRoute } = location.state as LocationState;
    const navigate = useNavigate();

    useEffect(() => {
        if (product === undefined) {
            navigate(RoutePaths.Product);
        }
    }, []);

    return { product, productRoute };
};
